import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Template Wizard</Typography>
      <p>When you create a new template, we need to walk you through providing 
        essential details. 
      </p>

      <p>Please ensure all fields are filled as required. Pay particular attention to 
        pass sharing. You can only select one of the two Google single user options if you
        do so before issuing any passes. As soon as you issue a single pass (even a test pass)
        you will be unable to select these options if you initially chose the default of 
        <i>multiple users</i>.
      </p>

      <p>All of these options can be modified in the visual editor, so do not worry if 
        you get anything wrong, you can change it later. We are just ensuring that every 
        required field has a value and that your template is close to what you need. 
      </p>
    </div>
  )
}

export default HelpText